import script from "./trends.vue?vue&type=script&setup=true&lang=js"
export * from "./trends.vue?vue&type=script&setup=true&lang=js"

import "./trends.vue?vue&type=style&index=0&id=1c7e824b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c7e824b"]])

export default __exports__